// extracted by mini-css-extract-plugin
export default {"tasks":"aO-z","task":"bO-z","svg":"cO-z","text":"dO-z"};